import React from 'react';
import CartPanel from './CartPanel';

/** Общий UI с `CartPanel` в модалке; ширина — как у остальных страниц в `MainLayout`. */
const Cart = () => {
    return (
        <div className="w-full pb-8">
            <CartPanel mode="page" />
        </div>
    );
};

export default Cart;
